import React, { useContext } from 'react';
import styled from 'styled-components';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import moment from 'moment';

const WrapperTextField = styled(TextField)`
  width: ${(props) => (props.width ? props.width : '100%')} !important;

  label {
    width: 100%;
  }
  .MuiInputLabel-root {
    font-size: 16px;
    line-height: 16px;
    color: #292d32;
    font-family: outfit_regular;
    transform: none;
  }

  .MuiInput-root {
    border: 1px solid #eaeaea !important;
    height: 50px !important;
    color: ${(props) => props.theme.lightGray};
    font-family: outfit_regular;
    font-size: 16px;
    line-height: 16px;

    ${(props) =>
      props.disabled &&
      `
      background-color: #f5f5f5 !important;
      cursor: not-allowed !important;

      .MuiInputBase-input {
        cursor: not-allowed !important;
      }

      .MuiSvgIcon-root {
        cursor: not-allowed !important;
      }
    `}

    &:before {
      border-bottom: 1px solid #eaeaea !important;
    }
    &:after {
      border-bottom: 1px solid #eaeaea !important;
    }

    .MuiSelect-select {
      background: none !important;
    }

    .MuiSelect-nativeInput {
      padding: ${(props) => props.inputPadding};
      color: #292d32;
      opacity: 1;
      height: 46px !important;
      bottom: 1px;
      font-family: outfit_regular;
      line-height: 16px;
      background: ${(props) =>
        props.background ? props.background : 'none'} !important;

      &::placeholder {
        color: ${(props) =>
          props.placeholderColor ? props.placeholderColor : '#959595'};
        font-size: 16px;
      }
    }

    .MuiSvgIcon-root {
      position: cc;
      margin-left: ${(props) => (props.locale === 'en' ? '' : '16px')};
      margin-top: ${(props) => (props.marginTop ? props.marginTop : '')};
      border: 1px solid ${(props) => props.theme.darkArrow};
      border-width: 0 2px 2px 0;
      display: inline-block;
      transform: rotate(45deg);
      -webkit-transform: rotate(45deg);
      padding: 3px;
      font-size: 16px;
      right: 15px;
      color: ${(props) => (props.colorIcon ? props.colorIcon : '#c56616')};
      width: 10px;
      height: 10px;
    }

    .MuiSvgIcon-root.MuiSelect-iconOpen {
      transform: rotate(-135deg);
      -webkit-transform: rotate(-135deg);
      top: calc(50% - 0em);
    }
  }

  .MuiInput-root.Mui-focused {
    border-bottom: none !important;
    color: red;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  &:hover {
    background-color: #fff2f8 !important;
    color: #292d32 !important;
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 14px;
  color: red;
  line-height: 16px;
  font-family: outfit_regular;
  position: absolute;
  bottom: 0px;
`;

function SelectInputBorder({ containerProps, ...props }) {
  return (
    <FormControl fullWidth>
      <WrapperTextField
        select
        id="standard-required"
        variant="standard"
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        {...props}
      >
        {props?.data?.length > 0 &&
          props?.data.map((k, i) => (
            <StyledMenuItem
              onClick={(e) => props?.getValue && props?.getValue(e, k)}
              key={k.id}
              value={k}
            >
              {k.name ||
                (k?.date && moment(k?.date).format('Do MMMM, YYYY')) ||
                k.provider_name}
            </StyledMenuItem>
          ))}
      </WrapperTextField>

      {props.errorText && <WrapperErrorDiv>{props.errorText}</WrapperErrorDiv>}
    </FormControl>
  );
}

SelectInputBorder.defaultProps = {
  height: 50,
  inputPadding: '14px',
};

export default SelectInputBorder;
